// extracted by mini-css-extract-plugin
module.exports = {"estimatedScores":"style-module__estimatedScores___3SYpC"};